import { Star } from "lucide-react";

const StarRating = ({ rating = 5, size = 14, className = "", testId = "star-rating" }) => {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  return (
    <span
      data-testid={testId}
      aria-label={`Rated ${rating} out of 5`}
      className={`inline-flex items-center gap-0.5 ${className}`}
    >
      {Array.from({ length: 5 }).map((_, i) => {
        const filled = i < full || (i === full && half);
        return (
          <Star
            key={i}
            size={size}
            className={filled ? "" : "opacity-25"}
            style={{ color: "#E6C229" }}
            fill={filled ? "#E6C229" : "none"}
            strokeWidth={1.8}
          />
        );
      })}
    </span>
  );
};

export default StarRating;
